import React, { useState } from 'react';
import SaveButtonWithModal from '../SaveButtonWithModel';

const languages = [
  'No Metric', 'Metric ', 'Studied Agriculture in School', 'Tertiary Qualification', 'Agricultural College',
  'Post Graduate', 'On-Job Training ', '-',
];

const ProfingSkils = ({ selectedSkills = [], setSelectedSkills, onSave }) => {
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");

  const handleToggle = (lang) => {
    if (lang === '-') return;
    if (selectedSkills.includes(lang)) {
      setSelectedSkills(selectedSkills.filter((item) => item !== lang));
      setError(""); // Clear error when a valid selection is made
    } else {
      if (selectedSkills.length >= 3) {
        setError("You can select up to 3 items only.");
        return;
      }
      setSelectedSkills([...selectedSkills, lang]);
      setError(""); // Clear error when a valid selection is made
    }
  };

  const handleSave = () => {
    if (selectedSkills.length === 0) {
      setError("This section is required. Please select at least one skill/training.");
      return; // Prevent save if no selection
    }
    setError(""); // Clear error if validation passes
    if (onSave) onSave({ "Personal Skills Training and Qualifications": selectedSkills });
  };

  return (
    <div className="w-full px-2 md:px-0 overflow-x-hidden md:block hidden">
      <div className="md:mt-6 mt-3 md:mb-6">
        <h1 className="md:text-[32px] text-[8px] font-bold">
          Personal Skills Training and Qualifications
        </h1>
        <p className="md:text-[20px] italic font-light text-[6px]">
          Select all relevant boxes that apply to you/the members of your co-operative or company.
        </p>
      </div>

      <div className="md:w-full md:mt-5">
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-1 md:gap-4">
          {languages.map((lang, i) => {
            const isActive = selectedSkills.includes(lang);

            let content;
            if (lang === 'Tertiary Qualification') {
              content = (
                <span className="leading-tight">
                  <span className="font-medium md:text-[32px] text-[8px]">Tertiary </span>
                  <span className="font-medium md:text-[20px] text-[6px]">Qualification</span>
                </span>
              );
            } else if (lang === 'Studied Agriculture in School') {
              content = ( 
                <div className="leading-tight">
                  <div className="font-medium md:text-[32px] text-[8px] -mb-1.5">Studied Agriculture</div>
                  <div className="font-medium md:text-[20px] text-[6px]">in School</div>
                </div>
              );
            } else {
              content = (
                <span className="font-medium md:text-[32px] text-[6px] leading-tight">{lang}</span>
              );
            }

            return (
              <button
                key={i}
                onClick={() => handleToggle(lang)}
                disabled={(lang === '-') || (!isActive && selectedSkills.length >= 3)}
                className="flex items-center justify-between md:w-full w-[200px] h-[20px] md:h-[72px] bg-[#E7EBEB] border border-[#E7EBEB] rounded-[5px] 
                  "
              >
                <div className="bg-[#E7EBEB] h-[20px] md:h-[72px] w-full md:w-[330px] text-left inline-flex items-center md:pt-3 md:pl-6 pl-2">
                  {content}
                </div>
                <span
                  className={`mr-2 md:mr-4 rounded-full 
                    ${isActive ? 'bg-[#03897B] border-white' : 'bg-transparent border-white'}
                    md:w-14 md:h-14 md:border-[8px] w-3 h-3 border-[3px]`}
                />
              </button>
            );
          })}
        </div>
      </div>
      {/* Use a normal button for save */}
  
      <div className="mt-4">
        <SaveButtonWithModal onClick={handleSave} />
      </div>

      {/* Error message moved to the bottom */}
      {error && <div className="text-red-500 text-xs mt-2">{error}</div>}
      {/* Modal shown only if validation passes */}
      {showModal && <SaveButtonWithModal isOpen={showModal} onRequestClose={() => setShowModal(false)} />}
    </div>
  );
};

export default ProfingSkils;